import React, { Component } from 'react';

import { StringUtils } from '../utils';
import { Routes as routes } from '../navigation';
import '../css/PracticeJoinRequests.css';

class PracticeJoinRequests extends Component {

  constructor(props) {
    super(props);
    this.state = {
      displayAcceptForRequestId: '',
      requestSelectedLocations: {},
      requestSelectedRoles: {},
      selectedRolesChanged: false,
    }
  }

  renderRolesRow = (roles) => {
    const currentPractice = this.props.practices && this.props.practices[this.props.selectedPractice];

    if (!currentPractice) {
      return null;
    }

    var roleOptions = [];

    roleOptions.push( currentPractice.type === "MEDICAL" ? { label: 'Veterinarian', role: 'vet' } : { label: 'Behaviorist', role: 'behaviorist' });
    roleOptions.push({ label: 'Practice Manager', role: 'practice_manager' });
    roleOptions.push({ label: 'Practice Owner',   role: 'practice_owner'   });
    roleOptions.push({ label: 'Tech',             role: 'tech'             });

    const roleRow = roleOptions.map((role) => {
      const rolesToCheck = this.state.selectedRolesChanged ? this.state.requestSelectedRoles : roles;
      const selected = rolesToCheck[role.role] === true ? true : false;
      return <input key={role.role}
                    className={`button-clear ${ selected ? 'button-clear-selected' : '' }`}
                    style={{ margin: 5 }}
                    value={role.label}
                    type="submit"
                    onClick={ () => {
                      var originalRoles = Object.assign({}, rolesToCheck);
                      originalRoles[role.role] = !originalRoles[role.role];
                      this.setState({ ...this.state, selectedRolesChanged: true, requestSelectedRoles: originalRoles })
                    }}
                  />
    })

    return <div>
      { roleRow }
    </div>
  }

  renderAcceptInterface = (request, user, role, locations) => {
    if (this.state.displayAcceptForRequestId !== request._id) {
      return null;
    }

    const addressRows = locations.map((location) => {

      var addressObject = {};
      addressObject.street_address = location.street_address;
      addressObject.city = location.city;
      addressObject.state = location.state;
      addressObject.location_id = location._id;
      addressObject.practice_id = location.practice_id;

      const locationSelected = this.state.requestSelectedLocations[location._id] && this.state.requestSelectedLocations[location._id] === true ? true : false;

      return <div className={`flex-container flex-container-column button-clear ${locationSelected ? 'button-clear-selected' : ''}`}
                  style={{ marginTop: 10 }}
                  key={location._id}
                  onClick={ () => {
                    var currentlySelected = this.state.requestSelectedLocations;
                    currentlySelected[location._id] = !locationSelected;
                    this.setState({ ...this.state, requestSelectedLocations: currentlySelected })
                  }}>
        <span>{ addressObject.street_address }</span>
        <span>{ addressObject.city + ' ' + addressObject.state }</span>
      </div>
    })

    const numOfSelectedLocationKeys = Object.keys(this.state.requestSelectedLocations);
    const selectedLocations = numOfSelectedLocationKeys.map((id) => {
      if (this.state.requestSelectedLocations[id] === true) {
        return id;
      }
    }).filter((id) => { return id })

    const totalNumSelected = Object.keys(selectedLocations).length;
    const atLeastOneLocationSelected = totalNumSelected > 0;
    const atLeastOneRoleSelected = this.checkForRolesSelected(role);
    const activateAcceptButton = atLeastOneLocationSelected && atLeastOneRoleSelected;

    return <div style={{ marginTop: 10 }}>
      <span style={{ marginTop: 10 }}>Select Role(s) to add this user as</span>
      <div className="flex-container flex-container-row"  style={{ marginBottom: 10, marginTop: 5 }}>
        { this.renderRolesRow(role) }
      </div>
      <span>Select Practice Location(s) to add this user to</span>
      <div className="flex-container flex-container-column">
        { addressRows }
      </div>
      <div className="flex-container" style={{ marginTop: 15, justifyContent: 'flex-end' }}>
        <input  type="submit"
                style={{ marginRight: 10, backgroundColor: activateAcceptButton ? '' : 'grey' }}
                className="button-default"
                value="Accept"
                onClick={ () => {
                  const rolesToAssign = this.state.selectedRolesChanged ? this.state.requestSelectedRoles : role;
                  const locationsToAssign = this.state.requestSelectedLocations;
                  this.acceptJoinRequest(this.props.token, request, rolesToAssign, locationsToAssign);
                }}
              />
        <input  type="submit"
                className="button-clear"
                value="Cancel"
                onClick={ () => {
                  this.setState({ ...this.state, displayAcceptForRequestId: '', requestSelectedLocations: {}, requestSelectedRoles: {}, selectedRolesChanged: false });
                }}
              />
      </div>
    </div>
  }

  renderPracticeJoinRequests = (requests, locations) => {
    const displayRequests = requests && requests.length > 0 ? true : false;
    if (!displayRequests || locations.length === 0) {
      return null;
    }

    var requestRows = [];
    var notifications = this.props.notifications || [];

    requests.forEach((request) => {
      const user = this.props.users && this.props.users[request.user_id] ? this.props.users[request.user_id] : {};
      const role = this.props.userRoles && this.props.userRoles[request.user_id] ? this.props.userRoles[request.user_id] : {};
      const name = StringUtils.displayName(user);
      const hideAcceptButton = this.state.displayAcceptForRequestId === request._id ? true : false;
      const notification     = this.getNotificationForRow(request.user_id, notifications);
      const notification_id  = notification && notification._id ? notification._id : '';
      const token = this.props.token;
      if (user && role) {
        requestRows.push(
          <div className="flex-container flex-container-column" key={request._id}>
            <div className="flex-container flex-container-row flex-center-align flex-space-between" style={{ marginTop: 10 }} key={request._id}>
              <span style={{ fontSize: 18 }}>{ name }</span>
              <span className='flex-container-row' style={{ alignItems: 'center' }}>
                { hideAcceptButton || !notification ? null : <div style={{ height: 10, width: 10, borderRadius: 5, backgroundColor: 'red', marginRight: 10 }}></div> }
                { hideAcceptButton ? null : <input className="button-default"
                                                   style={{ marginRight: 5 }}
                                                   type="submit"
                                                   value="Accept"
                                                   onClick={ () => {
                                                     if (token && notification_id) {
                                                       this.props.notificationsActions.markNotificationAsSeen(token, notification_id);
                                                     }
                                                     this.setState({ ...this.state, displayAcceptForRequestId: request._id })
                                                   }} />  }
                { hideAcceptButton ? null : <input className="button-clear"
                                                   type="submit"
                                                   value="Decline"
                                                   onClick={ () => {
                                                     if (token && notification_id) {
                                                       this.props.notificationsActions.markNotificationAsSeen(token, notification_id);
                                                     }
                                                     this.declineJoinRequest(this.props.token, request, role)
                                                   }} /> }
              </span>
            </div>
            { this.renderAcceptInterface(request, user, role, locations) }
          </div>
        )
      }
    })

    return <div className="basic-container">
      <h4 style={{ marginBottom: 20 }}>Requests To Join Practice</h4>
      { requestRows }
    </div>

  }

  render() {
    return this.renderPracticeJoinRequests(this.props.requests, this.props.practiceLocations);
  }

  getNotificationForRow = (requester_id, notifications) => {
    var notif = null;
    notifications.forEach((notification) => {
      if (notification && notification.data && notification.data.requester_id && notification.data.requester_id === requester_id) {
        notif = notification;
      }
    })
    return notif;
  }

  acceptJoinRequest = (token, request, roles, locations) => {

    const requestID = request._id;

    const finalizedRoles = {
      vet: roles.vet,
      behaviorist: roles.behaviorist,
      practice_manager: roles.practice_manager,
      practice_owner: roles.practice_owner,
      tech: roles.tech,
    };

    const locationIDs = Object.keys(locations).map((location_id) => {
      if (locations[location_id] === true) {
        return location_id;
      }
    }).filter((location_id) => { return location_id });

    if (token && requestID && locationIDs.length > 0) {
      this.props.practiceActions.acceptPracticeJoinRequest(token, requestID, finalizedRoles, locationIDs, roles.practice_id)
    }
  }

  declineJoinRequest = (token, request, role) => {
    const practice_id = request.practice_id;
    const user_id = request.user_id;
    if (token && practice_id && user_id) {
      this.props.practiceActions.declinePracticeJoinRequest(token, practice_id, user_id)
    }
  }

  checkForRolesSelected = (originalRoles) => {
    if (!this.state.selectedRolesChanged) {
      return true;
    }

    var anyTrue = false;
    const newRoles = this.state.requestSelectedRoles;
    Object.keys(newRoles).forEach((key) => {
      if (newRoles[key] === true) {
        anyTrue = true;
      }
    });

    return anyTrue;
  }

}


export default PracticeJoinRequests
